import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import SuccessImage from '../images/success.svg'
import ErrorImage from '../images/error.svg'

import { removeFlashMessage } from 'redux-flash-messages'
import { connect } from 'react-redux'


const ContainerStyle = styled.div`
  margin: 0 auto;
  background-color: #595967;
  width: 100%;
  height: 110px;
  text-align: center;
  border-top: 1px solid black;
`
const ContentPanelStyle = styled.div`
  position: relative;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  padding: 0px;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`
const CircleStyle = styled.div`
  //margin: 26px auto auto auto;
  margin: auto;
  width: 50%;
  border-radius: 50%;
  border:1px solid #FFFFFF;
  width: 36px;
  height: 36px;
`

const ErrorIconDiv = styled.div`
  margin: auto;
  width: 50%;
  width: 36px;
  height: 36px;
`

const SuccessImageStyle = styled.img`
  margin-top: 12px;
  width: 18px;
  height: 14px;
  `
const ErrorImageStyle = styled.img`
  width: 38px;
  height: 38px;
  `

const AlertArea = styled.div`
  width: 480px;
  display: table;
  margin: 0 auto;
  text-align: center;
  position: relative;
  bottom: 111px;
  z-index: 1;
  border: 1px solid black;
`

const AlertText = styled.span`
  font-family: Lato-Light;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
  margin-top: 6px;
`

export class AlertMessage extends Component {

  constructor(props) {
    super(props);

    let show = false
    let message = null

    if (props.message) {
      message = props.message;
      show = true;
    }

    this.state = {message: message, show: show, classes: ""};
  }

  static getDerivedStateFromProps(props, state){
    console.log("getDerivedStateFromProps message: " + props.message?.text)

    return {message: props.message, show: props.message != null, classes: props.message != null ? 'alertmsgslidein' : ''}
  }

  render () {
    const { t, message } = this.props

    console.log("rendering with message: " + message?.text)
    console.log(message)
    console.log("rendering with classes: " + this.state.classes)

    return (
      <div className={"alertcontainer"}>
          <AlertArea className={this.state.classes}>
            <ContainerStyle>
              <ContentPanelStyle role={'alert'}>
                {message?.type == "ERROR" &&
                  <ErrorIconDiv>
                    <ErrorImageStyle src={ErrorImage}/>
                  </ErrorIconDiv>
                }
                {message?.type == "SUCCESS" &&
                  <CircleStyle>
                    <SuccessImageStyle src={SuccessImage} alt={t('AlertTemplate.SuccessAlt')}/>
                  </CircleStyle>
                }
                <AlertText>{ message?.text || "" }</AlertText>
              </ContentPanelStyle>
            </ContainerStyle>
          </AlertArea>
      </div>
    )
  }
}

const mapState = state => ({
  messages: state.flashMessage.messages
})

const mapDispatchToProps = dispatch => ({
  removeFlashMessage: (id) => dispatch(removeFlashMessage(id))
})

export default connect(mapState, mapDispatchToProps)(withTranslation('translations')(AlertMessage))
